import * as css from './desktop.scss';
import * as footerDesktopCSS from '../footer/desktop.scss';
import {toggleClass, hasClass, parentWithClass, wrapLinkWithBiEvent, parseURI, $, $$} from '../../utils';
import {domains} from '../../data/constants.json';
import * as bi from '../../bi';

const focusGap = 20;

export function markCurrentMenuItem() {
  const url = window.__DEBUG__ ? `https://www.wix.com${location.pathname}` : location.href;
  const navLinks = document.querySelectorAll(`.${css.navigationItem}`);
  const currentLink = findCurrentMenuItem(navLinks, url);

  if (currentLink) {
    toggleClass(currentLink, css.current, true);
  }
  return this;
}

export function findCurrentMenuItem(navLinks, url) {
  for (let index = 0; index < navLinks.length; index++) {
    if (navLinks[index].querySelector(`a[href="${url}"]`)) {
      return navLinks[index].querySelector(`.${css.navigationItemContent}`);
    }
  }
  return null;
}

export function makeDropdownsAccessible() {
  $$(`.${css.hasDropdown}`)
    .forEach(dropdownContainer => {
      const dropdown = Array.from(dropdownContainer.children).filter(child => hasClass(child, css.dropdown))[0];
      if (!dropdown) {
        return;
      }
      dropdownContainer.addEventListener('focusout', event => {
        event.stopPropagation();
        dropdownContainer.preventFocusOut = false;
        setTimeout(() => {
          if (!dropdownContainer.preventFocusOut) {
            toggleClass(dropdownContainer, css.active, false);
            dropdownContainer.preventFocusOut = false;
          }
        }, focusGap);
      });
      dropdownContainer.addEventListener('focusin', () => {
        dropdownContainer.preventFocusOut = true;
        toggleClass(dropdownContainer, css.active, true);
      });
    });

  document.body.addEventListener('keyup', event => {
    if (event.keyCode !== 27) {
      return;
    }
    const dropdownContainer = parentWithClass(event.target, css.hasDropdown);
    if (dropdownContainer) {
      toggleClass(dropdownContainer, css.active, false);
    }
  });

  const container = document.querySelector(`.${css.container}`);
  if (container) {
    container.addEventListener('focusin', () => toggleClass(container, css.active, true));
    container.addEventListener('focusout', () => toggleClass(container, css.active, false));
  }

  return this;
}

export function bindClicks() {

  $$(`.${css.navigation} .${css.navigationItem} a`)
    .forEach(link => wrapLinkWithBiEvent(bi.legacyHeaderAndFooterBiLogger, link, bi.legacyhfConfig.clickOnHeader, link => {
      const tab = link.dataset.biTab;
      const subTab = link.dataset.biSubTab;

      return {
        tab,
        ...(subTab && {sub_tab: subTab}), // eslint-disable-line
        url: link.href,
        origin: location.href,
        row: subTab ? 'second' : 'first'
      };
    }));

  const signupLink = $(`.${css.signinButton}`);

  if (signupLink) {
    wrapLinkWithBiEvent(bi.legacyHeaderAndFooterBiLogger, signupLink, bi.legacyhfConfig.signinClick);
  }

  $$(`.${footerDesktopCSS.contentWrapper} .${footerDesktopCSS.menuItem} a`)
    .forEach(link => wrapLinkWithBiEvent(bi.legacyHeaderAndFooterBiLogger, link, bi.legacyhfConfig.clickOnFooter, link => {
      const uri = parseURI(link.href);
      const button_name = link.dataset.biName || (uri.hostname === domains.wix ? uri.pathname === '/' ? 'wix' : uri.pathname.substr(1) : uri.hostname);  // eslint-disable-line
      const type = link.closest(`.${footerDesktopCSS.menuColumn} `).querySelector(`.${footerDesktopCSS.menuHeading} `).dataset.biName;
      return {button_name, type}; // eslint-disable-line
    }));

  $$(`.${css.languagePicker} a`)
    .forEach(link => wrapLinkWithBiEvent(bi.legacyHeaderAndFooterBiLogger, link, bi.legacyhfConfig.languageChange, link => {
      const uri = parseURI(link.href);
      const name = link.dataset.biName ||
        (uri.hostname === domains.wix ? uri.pathname === '/' ? 'wix' : uri.pathname.substr(1) : uri.hostname);
      return {name};
    }));
  return this;
}

export function addOriginParamToLoginLink() {
  const signupLink = $(`.${css.signinButton}`);
  if (signupLink && signupLink.href && !signupLink.href.includes('originUrl')) {
    signupLink.href = signupLink.href.concat(`&originUrl=${encodeURIComponent(location.href)}`);
  }
}
